import { devNote } from '@xingternal/malt-util';

export const NSP_CORE = 'core';
export const NSP_LOCAL = 'local';
export const NSP_SEARCH = 'ds';
export const NSP_STARTPAGE = 'startpage';
export const NSP_NBA = 'nba';

export const QA_MALT = 'malt';
export const QA_FRAME = 'xingframe';
export const QA_PROFILE = 'profile';

export const FORM_PRISTINE = 'pristine';
export const FORM_DIRTY = 'dirty';
export const FORM_VALID = 'valid';
export const FORM_INVALID = 'invalid';

export const WEBFONT_URL =
  'https://www.xing.com/assets/frontend_minified/css/webfont-6ee69c71412d8bbc162bf9feaca16775.css';

devNote.deprecate(
  `The component @xingternal/malt-constants is discontinued. Please stop using it.`
);
